export const getLabelByValue = (list, value) => {
  const item = list.find((i) => i.value === value);
  return item ? item.label : "";
};
